<div class="ui segment topic-card" appMargin="0">
  <div fxLayout="row" fxLayoutAlign="center center" fxLayoutGap="10px">
    <div
      class="topic-details-section"
      fxFlex="60"
      fxLayout="column"
      fxLayoutGap="12px"
    >
      <h3 class="ui header topic-name">{{ topic.topic }}</h3>
      <h3 class="topic-date">
        Date Created: {{ topic.dateCreated | date: "EEEE d MMMM y" }}
      </h3>
      <p class="topic-author">Created By: {{ topic.createdBy | createdBy }}</p>
    </div>

    <div
      class="actions"
      fxFlex="40"
      fxLayout="row"
      fxLayoutGap="20px"
      fxLayoutAlign="space-between center"
    >
      <div class="ui basic primary dropdown" suiDropdown>
        <esl-button
          buttonType="primary"
          buttonSize="medium"
          buttonState="outline"
          buttonActionState="default"
          [hasLine]="true"
          [hasSuffixIcon]="true"
          [buttonMenu]="'dropdownMenu'"
          [hasDropdown]="true"
          [isClickable]="true"
        ></esl-button>
        <div class="left menu actions-dropdown" suiDropdownMenu>
          <div class="item" (click)="onAdd.emit(topic)">Add sub-topic</div>
          <div class="item" (click)="onEdit.emit(topic)">Edit topic</div>

          <div class="item" (click)="onDelete.emit(topic)">Delete topic</div>

          <div class="item" (click)="onView.emit(topic)">
            View Topic details
          </div>
        </div>
      </div>
      <ng-container *ngIf="topic.subtopicList && topic.subtopicList.length > 0">
        <button
          class="ui circular tiny button"
          suiPopup
          (click)="toggleSubtopic()"
          [popupInverted]="true"
          popupPlacement="bottom"
          [popupText]="collapseTopic ? 'Expand' : 'Collapse'"
        >
          <i
            [ngClass]="collapseTopic ? 'chevron down icon' : 'chevron up icon'"
          ></i>
        </button>
      </ng-container>
    </div>
  </div>
  <div class="topic-divider"></div>
</div>

<div
  class="ui vertical segment"
  *ngIf="!collapseTopic"
  [ngClass]="{ loading: pending }"
  appPadding="0"
>
  <app-chat-subtopic
    *ngFor="let subtopic of topic.subtopicList; let i = index"
    [subtopic]="subtopic"
    [parentTopic]="topic.topic"
    [isSelected]="parentTopic == selectedTopic && selectedSubtopic == subtopic"
    [activatedSubtopicId]="activatedSubtopicId"
    (viewAssignedUsers)="loadUsersScreen(subtopic, i)"
    (click)="onActivate.emit(subtopic)"
    (onView)="viewSubtopic(subtopic, topic)"
    (onDelete)="deleteSubtopic(subtopic)"
    (onEdit)="editSubtopic(subtopic, topic)"
    (onAdd)="assignSubtopicToUser.emit(subtopic)"
  ></app-chat-subtopic>
</div>
